module.exports = __webpack_public_path__ + "static/media/ba.118b12cd.svg";